import React from "react";
import { ButtonHTMLAttributes, ElementType } from "react";

interface TelefoneActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ElementType;
  iconColor?: string;
}

export function TelefoneAction({ icon: Icon, iconColor = "#52525b", ...rest }: TelefoneActionProps) {
  return <button {...rest}>{<Icon size={29} color={iconColor} />}</button>;
}
